import { RootState } from '../index';
import { createSelector } from '@reduxjs/toolkit';
import { CHAT_ROOM_TYPES } from './types';

export const selectChatRooms = (state: RootState) => state.chatRooms.entities;

export const selectRoomDataBySenderId = (senderId: string) =>
  createSelector(selectChatRooms, (rooms) => rooms.find((item) => item.room.specialist_id === senderId));

export const selectSortedChatRooms = createSelector(selectChatRooms, (items) => {
  const sortedArr = [...items].sort((a, b) => b.last_message.updated_at - a.last_message.updated_at);

  const broadcastRoomIndex = sortedArr.findIndex(({ room }) => room.type === CHAT_ROOM_TYPES.MINDLY_BROADCAST_ROOM);
  if (broadcastRoomIndex !== -1) {
    const [broadcastRoom] = sortedArr.splice(broadcastRoomIndex, 1);
    sortedArr.unshift(broadcastRoom);
  }

  return sortedArr;
});

export const selectIsInfiniteSelector = (state: RootState): boolean => {
  return state.chatRooms.isInfiniteDisabled;
};

export const selectorIsFirstLoading = (state: RootState): boolean => {
  return state.chatRooms.isFirstLoading;
};
